
export interface OperationDisplayConfig {
  labelTemplate: string;   // A sentence template
  iconPath: string;        // Path to the icon/image
}




export interface OperationInfoModel {

  device_id: string;
  operation: string;
  success: number;

}

export interface actionMetadataModel {


  previous_value?: string
  dependent_operation?: string
  current_value?: string
  schedule_name?: string
  start_time?: string
  end_time?: string
  schedule_type?: string
  operation_type?: string
  status?:string
  controller_activated_winter_mode?:string
  metadata?:string []



}



  export interface ActionHistoryModel {


    controller_uuid:string;
    device_id:string;
    date: string;
    files_id: string;
    firstname: string;
    lastname:string;
    has_access:boolean;
    operation_performed:string;
    metadata:string[];
  }


  export interface FilterOption {
    label: string;  // for display in dropdown
    value: string;  // for sending to API
    img_path:string,
  }



export const ACTION_CONFIGS: FilterOption[] = [

        { label: 'ADD DEVICE', value: 'add_device',img_path:"assets/img/action-history-add-device-icon.svg" },
        { label: 'DELETE DEVICE', value: 'delete_device',img_path:"assets/img/action-history-delete-device-icon.svg" },
        { label: 'INTELLIGENT MODE OFF', value: 'intelligent_mode_off',img_path:"assets/img/intelligent-mode-switch-device-details.svg"},
        { label: 'INTELLIGENT MODE ON', value: 'intelligent_mode_on',img_path:"assets/img/intelligent-mode-on-action-history.svg" },
        { label: 'INTELLIGENT MODE PAUSED', value: 'intelligent_mode_paused' ,img_path:"assets/img/intelligent-mode-on-action-history.svg"},
        { label: 'INTELLIGENT MODE RESUMED', value: 'intelligent_mode_resumed' ,img_path:"assets/img/intelligent-mode-on-action-history.svg"},
        { label: 'SET SPEED BY INTELLIGENT MODE', value: 'intelligent_mode_rpm' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'SCHEDULE', value: 'schedule' ,img_path:"assets/img/action-filter-schedule.svg"},
        { label: 'SET SPEED', value: 'set_speed' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'OFF', value: 'turn_off' ,img_path:"assets/img/action-history-turned-off-icon.svg"},
        { label: 'ON', value: 'turn_on' ,img_path:"assets/img/action-history-power-ico.svg"},
        { label: 'SET AUTO', value: 'set_auto' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'SET COOL', value: 'set_cool' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'SET HEAT', value: 'set_heat' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'SET TEMPERATURE', value: 'set_temperature' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'TURNED OFF WINTER MODE', value: 'winter_mode_off' ,img_path:"assets/img/winter-mode-on-controller.svg"},
        { label: 'TURNED ON WINTER MODE', value: 'winter_mode_on' ,img_path:"assets/img/winter-mode-on-controller.svg"},
        { label: 'CELL BOOST OFF', value: 'cell_boost_off' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'CELL BOOST ON', value: 'cell_boost_on' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'SET PRODUCTION', value: 'set_production' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'RESET PH TANK', value: 'reset_ph' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'SET ORP', value: 'set_orp' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'SET PH', value: 'set_ph' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'PH INJECT', value: 'ph_inject_onoff' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'CHANGE COLOR', value: 'change_color' ,img_path:"assets/img/action-filter-setting.svg"},
        { label: 'RESET LIFETIME', value: 'reset_uv' ,img_path:"assets/img/action-filter-setting.svg"},

]


export const OPERATION_CONFIGS: Record<string, OperationDisplayConfig> = {
  set_auto: {
    labelTemplate: 'has set auto mode on {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',
  },
  set_cool: {
    labelTemplate: 'has set cool mode on {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',
  },
  set_heat: {
    labelTemplate: 'has set heat mode on {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',
  },
  turn_on: {
    labelTemplate: 'has turned on {{device}}',
    iconPath: 'assets/img/action-history-power-ico.svg',
  },
  turn_off: {
    labelTemplate: 'has turned off {{device}}',
    iconPath: 'assets/img/action-history-turned-off-icon.svg',
  },
  schedule: {
    labelTemplate: 'has scheduled {{device}}',
    iconPath: 'assets/img/action-history-schedule.svg',
  },
  set_temperature: {
    labelTemplate: 'has set temperature of {{device}} from {{previous_value}} to {{current_value}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',
  },
  add_device: {
    labelTemplate: '{{device}} device added',
    iconPath: 'assets/img/action-history-add-device-icon.svg',
  },
  delete_device: {
    labelTemplate: '{{device}} device deleted',
    iconPath: 'assets/img/action-history-delete-device-icon.svg',
  },

    delete_schedule: {
    labelTemplate: 'has deleted the schedule ({{schedule_name}}) of time from {{start_time}} to {{end_time}}',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },


intelligent_mode_on: {
    labelTemplate: 'has enabled the intelligent mode',
    iconPath: 'assets/img/intelligent-mode-on-action-history.svg',

},

intelligent_mode_off: {
    labelTemplate: 'has disabled the intelligent mode',
    iconPath: 'assets/img/intelligent-mode-switch-device-details.svg',

},

winter_mode_on: {
    labelTemplate: 'has enabled winter mode',
    iconPath: 'assets/img/winter-mode-on-controller.svg',

},
winter_mode_off: {
    labelTemplate: 'has disabled winter mode',
    iconPath: 'assets/img/action-history-winter-mode-off-icon.svg',

},
winter_mode: {
    labelTemplate: 'has enabled winter mode, causing the controller to disable intelligent mode',
    iconPath: 'assets/img/winter-mode-on-controller.svg',

},

  set_speed: {
    labelTemplate: 'has set speed of {{device}} from {{previous_value}}rpm to {{current_value}}rpm',
    iconPath: 'assets/img/action-history-setting-ico.svg',
  },

    set_ph: {
    labelTemplate: 'has set pH value of {{device}} from {{previous_value}} to {{current_value}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',
  },
  set_orp: {
    labelTemplate: 'has set ORP of {{device}} from {{previous_value}}mV to {{current_value}}mV',
    iconPath: 'assets/img/action-history-setting-ico.svg',
  },

reset_ph: {
    labelTemplate: 'has reset pH tank capacity of {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',

},
reset_cl: {
    labelTemplate: 'has reset Cl tank capacity of {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',

},

cell_boost_on: {
    labelTemplate: 'has turned on cell boost of {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',


},
cell_boost_off: {
    labelTemplate: 'has turned off cell boost of {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',
},

intelligent_mode_rpm : {
    labelTemplate: 'has adjusted the speed from {{previous_value}}rpm to {{current_value}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',

},
ph_inject_onoff: {
    labelTemplate: 'has turned on pH inject of {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',

},
change_color: {
    labelTemplate: 'has changed color of SmartLight',
    iconPath: 'assets/img/action-history-setting-ico.svg',

},
reset_uv: {
    labelTemplate: 'has reset lifetime of UvLight',
    iconPath: 'assets/img/action-history-setting-ico.svg',

},

set_production:{
    labelTemplate: 'has set cell production percentage of {{device}} from {{previous_value}} to {{current_value}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',
},


winter_mode_alarm_deactivated:{
    labelTemplate: 'has deactivated winter mode',
    iconPath: 'assets/img/action-history-winter-mode-off-icon.svg',

},

winter_mode_alarm_activated:{
    labelTemplate: 'has activated winter mode',
    iconPath: 'assets/img/action-history-winter-mode-off-icon.svg',

},

intelligent_mode_resumed: {
      labelTemplate: 'Intelligent mode has resumed',
    iconPath: 'assets/img/intelligent-mode-on-action-history.svg',
},

intelligent_mode_paused: {
        labelTemplate: 'Intelligent mode has paused due to backwash',
    iconPath: 'assets/img/intelligent-mode-switch-device-details.svg',

},

  // Default or fallback
  default: {
    labelTemplate: 'performed {{operation}} on {{device}}',
    iconPath: 'assets/img/action-history-default-ico.svg',
  },
};








export const OPERATION_SCHEDULE_CONFIGS: Record<string, OperationDisplayConfig> = {
  set_auto: {
    labelTemplate: 'has set auto mode on {{device}}',
    iconPath: 'assets/img/action-history-setting-ico.svg',
  },
  set_cool: {
    labelTemplate: 'has set cool mode on {{device}}',
    iconPath: 'assets/img/action-history-cool-ico.svg',
  },
  set_heat: {
    labelTemplate: 'has set heat mode on {{device}}',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },
  turn_on: {
    labelTemplate: 'Schedule ({{schedule_name}}) of time from {{start_time}} and {{end_time}} has been started',
    iconPath: 'assets/img/action-history-power-ico.svg',
  },
  turn_off: {
    labelTemplate: 'Schedule ({{schedule_name}}) of time from {{start_time}} and {{end_time}} has been completed',
    iconPath: 'assets/img/action-history-power-ico.svg',
  },
  schedule: {
    labelTemplate: 'has set schedule ({{schedule_name}}) between {{start_time}} and {{end_time}} in {{schedule_type}} mode',
    iconPath: 'assets/img/action-history-clock-ico.svg',
  },
  set_temperature: {
    labelTemplate: 'has set temperature of {{device}} from {{previous_value}} to {{current_value}}',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },
  add_device: {
    labelTemplate: '{{device}} device added',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },
  delete_device: {
    labelTemplate: '{{device}} device deleted',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },

    delete_schedule: {
    labelTemplate: 'has deleted the schedule ({{schedule_name}}) of time from {{start_time}} to {{end_time}}',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },
    synced: {
    labelTemplate: 'Schedule from {{start_time}} to {{end_time}} is now synchronized',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },

    pending: {
    labelTemplate: 'Schedule from {{start_time}} to {{end_time}} is currently pending',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },
    disable_schedule: {
    labelTemplate: 'has disabled the schedule ({{schedule_name}}) of time from {{start_time}} to {{end_time}}',
    iconPath: 'assets/img/action-reached actionhistory-heat-ico.svg',
  },


  // Default or fallback
  default: {
    labelTemplate: 'performed {{operation}} on {{device}}',
    iconPath: 'assets/img/action-history-default-ico.svg',
  },
};
